import axios from 'axios';
import headers from "../Header";

let baseUrl = "/sdpi/data-approval"

class DataApprovalService {
    getDataApprovalKonfirmasiNik(param) {
        let url = ""
        if (param) {
            url = baseUrl + "/konfirmasi/nik" + param
        } else {
            url = baseUrl + "/konfirmasi/nik"
        }
        return axios.get(url, {
            headers: headers(),
        });
    }

    getDataApprovalBaruNik(param) {
        let url = ""
        if (param) {
            url = baseUrl + "/baru/nik" + param
        } else {
            url = baseUrl + "/baru/nik"
        }
        return axios.get(url, {
            headers: headers(),
        });
    }

    getDataAwal(nik, nomor_kk, kode_sls) {
        return axios.get(baseUrl + "/search-data-nik?nik=" + nik + "&nomor_kk=" + nomor_kk + "&kode_sls=" + kode_sls, {
            headers: headers(),
        });
    }

    getDataId(id) {
        return axios.get(baseUrl + "/search-data-id?id=" + id, {
            headers: headers(),
        });
    }

}

export default new DataApprovalService();